import {IsItDownDetailsPage} from "@/marketingPages/isitdown/details/IsItDownDetailsPage.tsx";
import {IsItDownPage} from "@/marketingPages/isitdown/list/IsItDownPage.tsx";
import {PublicLayout} from "@/marketingPages/PublicLayout.tsx";
import {createBrowserRouter, Navigate, RouteObject} from "react-router";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <PublicLayout />,
    children: [
      {index: true, element: <Navigate to="/status" replace />},
      {
        path: "/status",
        element: <IsItDownPage />,
      },
      {
        path: "/:slug",
        element: <IsItDownDetailsPage />,
      },
    ],
  },
];

const router = createBrowserRouter(routes);

export default router;
